import { createContext } from 'react';

export const DeviceContext = createContext({ type: "", size: "", isMobile: false });